<script>
import AccountDeletion from '~/pages/-lang/account-deletion.vue'

definePageMeta({
  layout: 'booking-layout',
})

export default AccountDeletion
</script>
